(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Filter-usage tracking (2026-08-30): pill quick-tags vs sidebar facets.
  // Publishes a Shopify custom event a Custom Pixel can forward to GA4, and pushes to dataLayer if present.
  (function () {
    function track(method, value) {
      var payload = { method: method, value: value, collection: location.pathname.split('/')[2] || '' };
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('enso_filter_use', payload); } catch (e) {}
      try { if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'enso_filter_use', filter_method: method, filter_value: value, collection: payload.collection }); } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var pill = e.target.closest && e.target.closest('.enso-pills a');
      if (pill) track('pill', (pill.textContent || '').trim().replace(/\s+/g, ' '));
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.facets__form, facets-form, .facets')) return;
      if (t.type === 'checkbox' && !t.checked) return;
      track('sidebar', (t.name || '') + '=' + (t.value || ''));
    }, true);
  })();

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
